<app-legal-layout
  eyebrow="Rechtliches"
  title="Impressum"
  lastUpdated="Mai 2026">

  <h2>Angaben gemäß § 5 DDG</h2>
  <address class="cr-legal__address">
    <strong>Kulatrix UG (haftungsbeschränkt)</strong><br>
    Alarichstraße 18<br>
    42281 Wuppertal<br>
    Deutschland
  </address>

  <h2>Kontakt</h2>
  <p>
    Telefon: <a href="tel:+4915252629106">+49 152 52629106</a><br>
    E-Mail: <a href="mailto:info&#64;kulatrix.com">info&#64;kulatrix.com</a><br>
    Web: <a href="https://kulatrix.com" target="_blank" rel="noopener">kulatrix.com</a>
  </p>

  <h2>Vertretungsberechtigter Geschäftsführer</h2>
  <p>Valentin Kulagin</p>

  <h2>Registereintrag</h2>
  <p>
    Eintragung im Handelsregister<br>
    Registergericht: Amtsgericht Wuppertal<br>
    Registernummer: HRB 36763
  </p>

  <h2>Umsatzsteuer-Identifikationsnummer</h2>
  <p>Umsatzsteuer-ID gemäß § 27 a Umsatzsteuergesetz: <strong>DE452644908</strong></p>

  <h2>Verantwortlich für den Inhalt nach § 18 Abs. 2 MStV</h2>
  <p>Valentin Kulagin<br>Anschrift wie oben</p>

  <h2>Online-Streitbeilegung (OS)</h2>
  <p>
    Die Europäische Kommission stellt eine Plattform zur Online-Streitbeilegung (OS) bereit, die Sie unter
    <a href="https://ec.europa.eu/consumers/odr" target="_blank" rel="noopener">https://ec.europa.eu/consumers/odr</a>
    finden.
  </p>

  <h2>Verbraucherstreitbeilegung / Universalschlichtungsstelle</h2>
  <p>
    Wir sind nicht bereit oder verpflichtet, an Streitbeilegungsverfahren vor einer
    Verbraucherschlichtungsstelle teilzunehmen.
  </p>

  <h2>Haftung für Inhalte</h2>
  <p>
    Als Diensteanbieter sind wir gemäß § 7 Abs. 1 DDG für eigene Inhalte auf diesen Seiten nach den
    allgemeinen Gesetzen verantwortlich. Nach §§ 8 bis 10 DDG sind wir als Diensteanbieter jedoch nicht
    verpflichtet, übermittelte oder gespeicherte fremde Informationen zu überwachen oder nach Umständen
    zu forschen, die auf eine rechtswidrige Tätigkeit hinweisen.
  </p>
  <p>
    Verpflichtungen zur Entfernung oder Sperrung der Nutzung von Informationen nach den allgemeinen
    Gesetzen bleiben hiervon unberührt. Eine diesbezügliche Haftung ist jedoch erst ab dem Zeitpunkt der
    Kenntnis einer konkreten Rechtsverletzung möglich. Bei Bekanntwerden von entsprechenden
    Rechtsverletzungen werden wir diese Inhalte umgehend entfernen.
  </p>

  <h2>Haftung für Links</h2>
  <p>
    Unser Angebot enthält Links zu externen Websites Dritter, auf deren Inhalte wir keinen Einfluss haben.
    Deshalb können wir für diese fremden Inhalte auch keine Gewähr übernehmen. Für die Inhalte der
    verlinkten Seiten ist stets der jeweilige Anbieter oder Betreiber der Seiten verantwortlich. Die
    verlinkten Seiten wurden zum Zeitpunkt der Verlinkung auf mögliche Rechtsverstöße überprüft.
    Rechtswidrige Inhalte waren zum Zeitpunkt der Verlinkung nicht erkennbar.
  </p>
  <p>
    Eine permanente inhaltliche Kontrolle der verlinkten Seiten ist jedoch ohne konkrete Anhaltspunkte
    einer Rechtsverletzung nicht zumutbar. Bei Bekanntwerden von Rechtsverletzungen werden wir derartige
    Links umgehend entfernen.
  </p>

  <h2>Urheberrecht</h2>
  <p>
    Die durch die Seitenbetreiber erstellten Inhalte und Werke auf diesen Seiten unterliegen dem deutschen
    Urheberrecht. Die Vervielfältigung, Bearbeitung, Verbreitung und jede Art der Verwertung außerhalb
    der Grenzen des Urheberrechtes bedürfen der schriftlichen Zustimmung des jeweiligen Autors bzw.
    Erstellers.
  </p>
  <p>
    Soweit die Inhalte auf dieser Seite nicht vom Betreiber erstellt wurden, werden die Urheberrechte
    Dritter beachtet. Insbesondere werden Inhalte Dritter als solche gekennzeichnet. Sollten Sie trotzdem
    auf eine Urheberrechtsverletzung aufmerksam werden, bitten wir um einen entsprechenden Hinweis. Bei
    Bekanntwerden von Rechtsverletzungen werden wir derartige Inhalte umgehend entfernen.
  </p>

</app-legal-layout>
